export const activityReplyKeys = {
    activity: (activityId: string) => ["activityReplies", activityId] as const,
    detail: (id: string) => ["activityReply", id] as const,
    unreadStatus: ["activityRepliesUnreadStatus"] as const,
};
